import { PaperType } from '../types/pastPaper';

export interface DefaultPastPaperSeed {
  subjectCode: 'COMBINED_MATHS' | 'PHYSICS' | 'CHEMISTRY' | 'BIOLOGY' | 'ICT';
  year: number;
  paperType: PaperType;
  paperLabel: string;
}

export const PAST_PAPER_YEARS = Array.from({ length: 17 }, (_, i) => 2010 + i); // 2010..2026

export const DEFAULT_PAST_PAPERS_SEED: DefaultPastPaperSeed[] = [];

for (const year of PAST_PAPER_YEARS) {
  // Combined Maths
  DEFAULT_PAST_PAPERS_SEED.push({
    subjectCode: 'COMBINED_MATHS',
    year,
    paperType: 'PAPER_I',
    paperLabel: `${year} Combined Maths - Paper I (Pure Maths)`,
  });
  DEFAULT_PAST_PAPERS_SEED.push({
    subjectCode: 'COMBINED_MATHS',
    year,
    paperType: 'PAPER_II',
    paperLabel: `${year} Combined Maths - Paper II (Applied Maths)`,
  });

  // Physics
  DEFAULT_PAST_PAPERS_SEED.push({
    subjectCode: 'PHYSICS',
    year,
    paperType: 'PAPER_I',
    paperLabel: `${year} Physics - Paper I (MCQ)`,
  });
  DEFAULT_PAST_PAPERS_SEED.push({
    subjectCode: 'PHYSICS',
    year,
    paperType: 'PAPER_II',
    paperLabel: `${year} Physics - Paper II (Structured & Essay)`,
  });

  // Chemistry
  DEFAULT_PAST_PAPERS_SEED.push({
    subjectCode: 'CHEMISTRY',
    year,
    paperType: 'PAPER_I',
    paperLabel: `${year} Chemistry - Paper I (MCQ)`,
  });
  DEFAULT_PAST_PAPERS_SEED.push({
    subjectCode: 'CHEMISTRY',
    year,
    paperType: 'PAPER_II',
    paperLabel: `${year} Chemistry - Paper II (Structured & Essay)`,
  });
  DEFAULT_PAST_PAPERS_SEED.push({
    subjectCode: 'BIOLOGY',
    year,
    paperType: 'PAPER_I',
    paperLabel: `${year} Biology - Paper I`,
  });
  DEFAULT_PAST_PAPERS_SEED.push({
    subjectCode: 'BIOLOGY',
    year,
    paperType: 'PAPER_II',
    paperLabel: `${year} Biology - Paper II`,
  });
  DEFAULT_PAST_PAPERS_SEED.push({
    subjectCode: 'ICT',
    year,
    paperType: 'PAPER_I',
    paperLabel: `${year} ICT - Paper I`,
  });
  DEFAULT_PAST_PAPERS_SEED.push({
    subjectCode: 'ICT',
    year,
    paperType: 'PAPER_II',
    paperLabel: `${year} ICT - Paper II`,
  });
}
